import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import '../styles/LandingPage.css';


export default function LandingPage() {
  return (
    <div className="app-bg text-light">
      <NavBar />
      <main>
        <Hero />
        <div className='landing-bg'>
          <Stats />
          <Features />
          <HowItWorks />
          <Safety />
          <Testimonials />
          <CTA />
          <FAQ />
          <ContactUs />
        </div>
      </main>
      <div className='landing-bg'>
        <Footer />
      </div>
    </div>
  )
}

/* ----------------------- NAVBAR ----------------------- */
function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-transparent sticky-top py-3">
      <div className="container">
        <a className='text-decoration-none text-reset' href='#'>
          <Logo />
        </a>
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#nav"
          aria-controls="nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="bi bi-list fs-1 text-accent"></i>
        </button>

        <div className="collapse navbar-collapse" id="nav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-lg-3">
            <li className="nav-item">
              <a className='text-decoration-none text-reset' href='#contact'>Contact</a>
            </li>
            <li className="nav-item">
              <a className='text-decoration-none text-reset' href='#how'>How it works</a>
            </li>
            <li className="nav-item">
              <a className='text-decoration-none text-reset' href='#faq'>FAQ</a>
            </li>
            <li className="nav-item">

              <Link className='text-decoration-none text-reset' to='/auth/login'>
                Sign up
              </Link>

            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}


function Logo() {
  return (
    <div className="d-flex align-items-center">
      <div className="logo-badge me-2">
        {/* <i className="bi bi-stars"></i> */}
        <img src={`${process.env.PUBLIC_URL}/meetvana_logo_transparent.png`} alt="Logo" style={{ width: '40px', height: 'auto', objectFit: 'contain', borderRadius: '12px' }}/>
      </div>
      <span className="brand-gradient fw-bold">eetvana</span>
    </div>
  )
}

/* ----------------------- HERO ----------------------- */
function Hero() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  }

  const handleSignUpClick = () => {
    navigate('/auth/login');
  };


  return (
    <section id="home" className="position-relative overflow-hidden">
      <div className="hero-gradient"></div>
      <div className="container py-6 position-relative">
        <div className="row align-items-center gy-5">
          <div className="col-lg-6">
            <h1 className="display-4 fw-bold lh-1 mb-3">
              Find <span className="text-accent">new friends</span>, in real life.
            </h1>
            <p className="lead text-muted-80 mb-4">
              Meetvana organizes anonymous meetups based on your location and shared interests.
              We suggest the place, time and group — just show up.
            </p>

            {/* <form className="d-sm-flex gap-2" onSubmit={onSubmit} id="signup">
              <input
                type="email"
                className="form-control form-control-lg glass-input"
                placeholder="Enter your email"
                aria-label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="btn btn-lg btn-cta px-4">
                Sign Up
              </button>
            </form> */}

            <button type="submit" className="btn btn-lg btn-cta px-4" onClick={handleSignUpClick}>
              Sign Up
            </button>
            <div className="d-flex align-items-center gap-3 mt-3 text-muted-60 small">
              <span><i className="bi bi-shield-check me-1"></i>No spam</span>
              <span className="d-none d-sm-inline">•</span>
              <span><i className="bi bi-geo-alt me-1"></i>Local meetups near you</span>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="phone-mockup mx-auto">
              {/* Placeholder UI */}
              <div className="phone-topbar">
                <div className="camera"></div>
              </div>
              <div className="phone-screen">
                <div className="screen-header">
                  <span className="dot dot-green"></span>
                  <span className="dot dot-yellow"></span>
                  <span className="dot dot-red"></span>
                </div>

                <div className="screen-card">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-geo-alt-fill text-accent me-2"></i>
                    <div>
                      <div className="small text-muted-60">Tonight • 19:00</div>
                      <div className="fw-semibold">Anonymous Coffee Circle</div>
                    </div>
                  </div>
                  <div className="mt-3 small text-muted-80">
                    5 matched by <span className="text-accent fw-semibold">hiking, indie films, UX</span>
                  </div>
                </div>

                <div className="screen-card">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-people-fill text-accent me-2"></i>
                    <div>
                      <div className="small text-muted-60">Saturday • 11:00</div>
                      <div className="fw-semibold">City Park Walk & Talk</div>
                    </div>
                  </div>
                  <div className="mt-3 d-flex">
                    <span className="badge glass-badge me-2"><i className="bi bi-compass me-1"></i>15 min away</span>
                    <span className="badge glass-badge"><i className="bi bi-hash me-1"></i>photography</span>
                  </div>
                </div>

                {/* <div className="screen-cta">
                  <button className="btn btn-cta w-100">Shuffle new groups</button>
                </div> */}
              </div>
            </div>
            <p className="text-center mt-3 text-muted-60 small">
              Mock UI. Actual app may look slightly different.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

/* ----------------------- STATS ----------------------- */
function Stats() {
  return (
    <section className="py-5">
      <div className="container">
        <div className="row text-center gy-4">
          <div className="col-6 col-md-3">
            <div className="stat-card glass">
              <div className="fs-3 fw-bold">Local</div>
              <div className="text-muted-60">IRL-first approach</div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="stat-card glass">
              <div className="fs-3 fw-bold">Anonymous</div>
              <div className="text-muted-60">Show up, be yourself</div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="stat-card glass">
              <div className="fs-3 fw-bold">Smart</div>
              <div className="text-muted-60">Interest-based groups</div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="stat-card glass">
              <div className="fs-3 fw-bold">Safe</div>
              <div className="text-muted-60">Controls & vetting</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

/* ----------------------- FEATURES ----------------------- */
function Features() {
  const items = [
    {
      icon: 'bi-shuffle',
      title: 'Anonymous matching',
      text: 'No profiles needed. Meetvana forms small IRL groups without exposing identity until you arrive.'
    },
    {
      icon: 'bi-geo',
      title: 'Location-smart suggestions',
      text: 'We suggest nearby venues and public places that fit your vibe and time window.'
    },
    {
      icon: 'bi-heart',
      title: 'Shared interests',
      text: 'Match on what matters—hiking, film, gaming, design, books, wellness, and more.'
    },
    {
      icon: 'bi-shield-lock',
      title: 'Safety first',
      text: 'Report, block, group size limits, and meet in vetted places. Community guidelines enforced.'
    },
    {
      icon: 'bi-calendar2-check',
      title: 'Calendar-friendly',
      text: 'Picks times that work for most people; add to calendar with a tap.'
    },
    {
      icon: 'bi-bell',
      title: 'Smart notifications',
      text: 'We nudge just enough—no spam. Opt in/out anytime.'
    }
  ]

  return (
    <section id="features" className="py-6">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Built for effortless, real-life connections</h2>
          <p className="text-muted-80">
            Meetvana recommends the <span className="text-accent">place</span>, the <span className="text-accent">group</span>, and the <span className="text-accent">time</span>.
          </p>
        </div>

        <div className="row g-4">
          {items.map((f, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div className="feature-card glass h-100">
                <div className="icon-wrap">
                  <i className={`bi ${f.icon}`}></i>
                </div>
                <h5 className="mt-3">{f.title}</h5>
                <p className="text-muted-80 mb-0">{f.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

/* ----------------------- HOW IT WORKS ----------------------- */
function HowItWorks() {
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    navigate('/auth/login');
  };

  const steps = [
    {
      icon: 'bi-emoji-smile',
      title: 'Tell us your vibe',
      text: 'Pick interests and when you’re free. No profile needed.'
    },
    {
      icon: 'bi-fingerprint',
      title: 'We match a small group',
      text: 'Anonymous matching based on similarity and proximity.'
    },
    {
      icon: 'bi-geo-alt',
      title: 'We suggest a place',
      text: 'We pick a vetted, public spot that fits everyone.'
    },
    {
      icon: 'bi-stars',
      title: 'Show up & connect',
      text: 'Just arrive—names optional. Keep it simple and human.'
    }
  ]

  return (
    <section id="how" className="py-6">
      <div className="container">
        <div className="row align-items-center gy-4">
          <div className="col-lg-5">
            <h2 className="fw-bold">How Meetvana works</h2>
            <p className="text-muted-80">
              We remove the awkward bits, so you can focus on the conversation.
            </p>
            <button type="submit" className="btn btn-lg btn-cta px-4" onClick={handleSignUpClick}>
              Sign Up
            </button>
          </div>
          <div className="col-lg-7">
            <div className="row g-4">
              {steps.map((s, i) => (
                <div className="col-sm-6" key={i}>
                  <div className="step-card glass h-100">
                    <div className="step-icon"><i className={`bi ${s.icon}`}></i></div>
                    <h6 className="mb-1">{s.title}</h6>
                    <p className="text-muted-80 mb-0">{s.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

/* ----------------------- SAFETY ----------------------- */
function Safety() {
  const points = [
    'Meet in public, vetted places by default',
    'Group sizes (3–6) to keep it comfortable',
    'Easy reporting & community guidelines',
    'Anonymous until you arrive'
  ]
  return (
    <section className="py-6">
      <div className="container">
        <div className="row align-items-center gy-4">
          <div className="col-lg-6 order-lg-2">
            <div className="safety-card glass">
              <h3 className="fw-bold mb-3"><i className="bi bi-shield-check me-2"></i>Safety & Privacy</h3>
              <ul className="list-unstyled m-0">
                {points.map((p, i) => (
                  <li className="d-flex align-items-start mb-2" key={i}>
                    <i className="bi bi-check2-circle text-accent me-2 mt-1"></i>
                    <span className="text-muted-80">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-6 order-lg-1">
            <h2 className="fw-bold">Feel safe showing up</h2>
            <p className="text-muted-80">
              Safety is built-in from the first match. Meet in small groups at public places, keep your details private, and stay in control.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

/* ----------------------- TESTIMONIALS ----------------------- */
function Testimonials() {
  const items = [
    {
      name: 'Maya',
      role: 'Designer',
      quote: 'It removed the pressure of profiles and DMs. I just met people who liked what I like.',
      avatar: 'https://i.pravatar.cc/100?img=32'
    },
    {
      name: 'Jon',
      role: 'Engineer',
      quote: 'Showed up to a coffee circle and it felt natural. Zero awkward small talk.',
      avatar: 'https://i.pravatar.cc/100?img=12'
    },
    {
      name: 'Lena',
      role: 'Researcher',
      quote: 'The group size and timing were perfect. I’ve gone to three meetups already.',
      avatar: 'https://i.pravatar.cc/100?img=5'
    }
  ]
  return (
    <section className="py-6">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">What our users say</h2>
          <p className="text-muted-80">Organic, low-pressure chats in real life.</p>
        </div>
        <div className="row g-4">
          {items.map((t, i) => (
            <div className="col-md-4" key={i}>
              <div className="testimonial-card glass h-100">
                <div className="d-flex align-items-center mb-3">
                  <img src={t.avatar} alt={`${t.name} avatar`} className="avatar me-3" />
                  <div>
                    <div className="fw-semibold">{t.name}</div>
                    <div className="text-muted-60 small">{t.role}</div>
                  </div>
                </div>
                <p className="mb-0">“{t.quote}”</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

/* ----------------------- CTA ----------------------- */
function CTA() {
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    navigate('/auth/login');
  };

  return (
    <section className="py-6">
      <div className="container">
        <div className="cta-card glass text-center p-5">
          <h2 className="fw-bold mb-2">Ready to meet your people?</h2>
          <p className="text-muted-80 mb-4">
            Discover Meetvana — the easiest way to connect with like-minded people in your city and build meaningful friendships.
          </p>
          <button type="submit" className="btn btn-lg btn-cta px-4" onClick={handleSignUpClick}>
            Sign Up
          </button>
        </div>
      </div>
    </section>
  )
}

/* ----------------------- FAQ ----------------------- */
function FAQ() {
  const qs = [
    {
      q: 'Is Meetvana a dating app?',
      a: 'No. Meetvana is focused on friendship, real-life group meetups around shared interests.'
    },
    {
      q: 'Do I need a public profile?',
      a: 'No public profile is required. You’ll only share your year of birth and basic interests with us. Matching is anonymous — your details remain private.'
    },
    {
      q: 'Where do meetups happen?',
      a: 'We suggest public, vetted places like cafés, parks, and community spaces within a reasonable distance.'
    },
    {
      q: 'How big are groups?',
      a: 'Typically 3–6 people. Small enough to feel comfortable, big enough to keep conversations flowing.'
    },
    {
      q: 'Is Meetvana free?',
      a: 'Yes, Meetvana is completely free to use. There are no hidden fees or subscriptions — just real connections around shared interests.'
    }
  ]
  return (
    <section id="faq" className="py-6">
      <div className="container">
        <h2 className="fw-bold text-center mb-4">Frequently asked questions</h2>
        <div className="accordion glass" id="faq-acc">
          {qs.map((item, idx) => (
            <div className="accordion-item bg-transparent border-0" key={idx}>
              <h2 className="accordion-header" id={`h-${idx}`}>
                <button
                  className={`accordion-button ${idx === 0 ? '' : 'collapsed'}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#c-${idx}`}
                  aria-expanded={idx === 0 ? 'true' : 'false'}
                  aria-controls={`c-${idx}`}
                >
                  {item.q}
                </button>
              </h2>
              <div
                id={`c-${idx}`}
                className={`accordion-collapse collapse ${idx === 0 ? 'show' : ''}`}
                aria-labelledby={`h-${idx}`}
                data-bs-parent="#faq-acc"
              >
                <div className="accordion-body text-muted-80">
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}



/* ----------------------- CONTACT ----------------------- */

function ContactUs() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
    website: '' // honeypot (anti-bot)
  });
  const [status, setStatus] = useState({ type: 'idle', message: '' });

  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // Honeypot check
    if (form.website) return;

    if ( !isValidEmail(form.email) || !form.message) {
      setStatus({
        type: 'error',
        message: 'Please fill out your name, a valid email, and a message.'
      });
      return;
    }

    setStatus({ type: 'loading', message: '' });

    try {
      const endpoint = process.env.REACT_APP_CONTACTFORM_URLBASE + '/api/v1/send-email';

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: form.email,
          message: form.message
        })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to send. Please try again.');
      }

      setStatus({
        type: 'success',
        message: 'Thanks! Your message has been sent. We will get back to you shortly.'
      });
      setForm({ email: '', message: '', website: '' });
    } catch (err) {
      setStatus({
        type: 'error',
        message: err.message || 'Something went wrong. Please try again later.'
      });
    }
  };

  return (
    <section id="contact" className="py-6">
      <div className="container">
        <div className="row justify-content-center gy-4">
          <div className="col-lg-8">
            <div className="p-4 p-md-5 rounded-4 contact-card glass-card">
              <div className="d-flex align-items-center mb-3">
                <div className="logo-badge me-2"><i className="bi bi-envelope-open"></i></div>
                <h2 className="fw-bold m-0">Contact us</h2>
              </div>

              <p className="text-muted-80 mb-4">
                Have a question, idea, or partnership? Send us a note and we’ll reply within 1–2 business days.
              </p>

              {status.type === 'success' && (
                <div className="alert alert-success" role="alert">
                  <i className="bi bi-check-circle me-2"></i>{status.message}
                </div>
              )}
              {status.type === 'error' && (
                <div className="alert alert-danger" role="alert">
                  <i className="bi bi-exclamation-triangle me-2"></i>{status.message}
                </div>
              )}

              <form onSubmit={onSubmit} noValidate>
                {/* Honeypot field (hidden) */}
                <input
                  type="text"
                  name="website"
                  value={form.website}
                  onChange={onChange}
                  className="d-none"
                  tabIndex="-1"
                  autoComplete="off"
                />

                <div className="row g-3">
                  

                  <div className="col-md-6">
                    <label htmlFor="contact-email" className="form-label">Email</label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      className="form-control glass-input"
                      placeholder="you@example.com"
                      value={form.email}
                      onChange={onChange}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <label htmlFor="contact-message" className="form-label">Message</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      className="form-control glass-input"
                      rows="5"
                      placeholder="Write your message..."
                      value={form.message}
                      onChange={onChange}
                      required
                    ></textarea>
                  </div>

                  <div className="col-12 d-flex align-items-center justify-content-between mt-2">
                    <div className="small text-muted-60">
                      <i className="bi bi-shield-check me-1"></i>
                      We never share your email.
                    </div>
                    <button
                      type="submit"
                      className="btn btn-cta px-4"
                      disabled={status.type === 'loading'}
                    >
                      {status.type === 'loading' ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : (
                        <>Send message</>
                      )}
                    </button>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ----------------------- FOOTER ----------------------- */
function Footer() {
  return (
    <footer className="py-5 border-top border-0 border-opacity-10">
      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
        <div className="d-flex align-items-center gap-2">
          <Logo />
          <span className="text-muted-60 small">© {new Date().getFullYear()} Meetvana</span>
        </div>

        <div className="d-flex align-items-center gap-2">
          <a className='text-decoration-none text-reset' href='/data-privacy'>Data Privacy</a>
        </div>

        <div className="d-flex align-items-center gap-3">
          <a className='text-decoration-none text-reset' href='#features'>Features</a>
          <a className='text-decoration-none text-reset' href='#how'>How it works</a>
          <a className='text-decoration-none text-reset' href='#faq'>FAQ</a>
          <div className="d-flex gap-2 ms-2">
            <a><i className="bi bi-twitter-x"></i></a>
            <a><i className="bi bi-instagram"></i></a>
            <a><i className="bi bi-discord"></i></a>
          </div>
        </div>
      </div>
    </footer>
  )
}
